import React, { useEffect, useState } from "react";
import axios from "axios";

const Cateringdeliveryorders = () => {
    const [allOrders, setAllOrders] = useState([]);
    const [vendorId, setVendorId] = useState(null);
    const [showDetails, setShowDetails] = useState({});

    useEffect(() => {
        const storedVendorId = localStorage.getItem("vendorId");
        if (storedVendorId) setVendorId(storedVendorId);
    }, []);

    useEffect(() => {
        if (!vendorId) return;

        const fetchOrders = async () => {
            const token = localStorage.getItem("authToken");
            if (!token) {
                console.error("Authorization token missing");
                return;
            }

            try {
                const response = await axios.get(
                    `http://10.10.20.9:7007/caterings-0.0.1-SNAPSHOT/api/vendor/getall/${vendorId}`,
                    { headers: { Authorization: `Bearer ${token}` } }
                );

                const allOrders = response.data || [];

                // ✅ Filter PREPARING orders
                const preparingOrders = allOrders.filter(
                    (order) => order.orderStatus === "PREPARING"
                );

                console.log("✅ Filtered PREPARING Orders:", preparingOrders);
                setAllOrders(preparingOrders);
            } catch (error) {
                console.error("❌ Error fetching orders:", error);
                alert(
                    "Error fetching orders:\n" +
                    (error.response?.data?.message || error.message)
                );
            }
        };

        fetchOrders();
    }, [vendorId]);

    // ✅ Styling
    const styles = {
        card: {
            border: "1px solid #ccc",
            padding: "16px",
            margin: "16px",
            borderRadius: "10px",
            background: "linear-gradient(to right, #f46b45, #eea849)",
            boxShadow: "0 3px 6px rgba(0,0,0,0.1)",
        },
        header: {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
        },
        statusButtons: {
            display: "flex",
            justifyContent: "center",
            gap: "10px",
            marginTop: "10px",
        },
        button: (active) => ({
            padding: "8px 16px",
            borderRadius: "8px",
            border: "none",
            color: active ? "white" : "#555",
            backgroundColor: active ? "green" : "#e0e0e0",
            fontWeight: "bold",
            cursor: active ? "default" : "not-allowed",
            boxShadow: active ? "0 4px 10px rgba(0,0,0,0.2)" : "none",
            transition: "0.3s",
        }),
    };

    // ✅ Status sequence order
    const statusSequence = ["PREPARING", "DELIVERED"];

    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-lg-12 leads-orders-page-data" style={{ height: "500px", overflow: "auto", scrollbarWidth: "none" }} >
                    {allOrders.length === 0 ? (
                        <p style={{ textAlign: "center", marginTop: "20px" }}>
                            No Catering Orders found with status{" "}
                            <strong>PREPARING</strong>.
                        </p>
                    ) : (
                        allOrders.map((order, index) => (
                            <div key={order.orderId || index} style={styles.card}>
                                <div style={styles.header}>
                                    <h3 style={{ fontWeight: "bold" }}>
                                        Order ID: {order.orderId || "N/A"}
                                    </h3>


                                    <button
                                        style={{
                                            background: "none",
                                            border: "none",
                                            fontSize: "20px",
                                            cursor: "pointer",
                                        }}
                                        onClick={() =>
                                            setShowDetails((prev) => ({
                                                ...prev,
                                                [order.orderId]: !prev[order.orderId],
                                            }))
                                        }
                                    >
                                        {showDetails[order.orderId] ? "▲" : "▼"}
                                    </button>
                                </div>

                                {/* ✅ Three-Stage Order Status Buttons */}


                                {showDetails[order.orderId] && (
                                    <>
                                        <p style={{ fontSize: "16px", marginTop: "10px" }}>
                                            <strong>Date:</strong>{" "}
                                            {new Date(order.orderDateTime).toLocaleDateString("en-IN")}
                                            <br />
                                            <strong>Time:</strong>{" "}
                                            {new Date(order.orderDateTime).toLocaleTimeString("en-IN", {
                                                hour: "2-digit",
                                                minute: "2-digit",
                                                second: "2-digit",
                                            })}
                                        </p>

                                        <table
                                            style={{
                                                width: "100%",
                                                borderCollapse: "collapse",
                                                marginTop: "1rem",
                                            }}
                                        >
                                            <thead>
                                                <tr
                                                    style={{
                                                        backgroundColor: "#b15cd6",
                                                        color: "white",
                                                        textAlign: "center",
                                                    }}
                                                >
                                                    <th style={{ padding: "8px", border: "1px solid #ddd" }}>
                                                        #
                                                    </th>
                                                    <th style={{ padding: "8px", border: "1px solid #ddd" }}>
                                                        Package Name
                                                    </th>
                                                    <th style={{ padding: "8px", border: "1px solid #ddd" }}>
                                                        Type
                                                    </th>
                                                    <th style={{ padding: "8px", border: "1px solid #ddd" }}>
                                                        Price (₹)
                                                    </th>
                                                    <th style={{ padding: "8px", border: "1px solid #ddd" }}>
                                                        Quantity
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {order.orderItems?.map((pkg, i) => (
                                                    <tr
                                                        key={i}
                                                        style={{
                                                            textAlign: "center",
                                                            borderBottom: "1px solid #eee",
                                                            backgroundColor: "#f8f9fa",
                                                            fontWeight: "bold",
                                                        }}
                                                    >
                                                        <td>{i + 1}</td>
                                                        <td>{pkg.packageName}</td>
                                                        <td>{pkg.packageType}</td>
                                                        <td>{pkg.packagePrice}</td>
                                                        <td>{pkg.quantity}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </>
                                )}

                                <div style={styles.statusButtons}>
                                    {statusSequence.map((status) => (
                                        <button
                                            key={status}
                                            style={styles.button(order.orderStatus === status)}
                                            disabled
                                        >
                                            {status}
                                        </button>
                                    ))}
                                </div>
                            </div>
                        ))
                    )}
                </div>
            </div>
        </div>
    );
};

export default Cateringdeliveryorders;
